import { render, staticRenderFns } from "./CardTaxonomia.vue?vue&type=template&id=7d0bf1ce&scoped=true&"
import script from "./CardTaxonomia.vue?vue&type=script&lang=js&"
export * from "./CardTaxonomia.vue?vue&type=script&lang=js&"
import style0 from "./CardTaxonomia.vue?vue&type=style&index=0&id=7d0bf1ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0bf1ce",
  null
  
)

export default component.exports